module.exports = __webpack_public_path__ + "media/splash/launch-2048x2732-f99453f9.png";